// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PartnerScoreAssetManager from "./PartnerScoreAssetManager.bs.js";

var footer_icon = PartnerScoreAssetManager.getImage("stars.svg");

var lock_icon = PartnerScoreAssetManager.getImage("lock-icon.svg");

var info_icon = PartnerScoreAssetManager.getImage("info.svg");

var pin_icon = PartnerScoreAssetManager.getImage("down-arrow-icon.svg");

var video_icon = PartnerScoreAssetManager.getImage("video.svg");

var close_icon = PartnerScoreAssetManager.getImage("close.svg");

var error_img = PartnerScoreAssetManager.getImage("error.svg");

var dropdown_icon = PartnerScoreAssetManager.getImage("dropdown.svg");

var warning_icon = PartnerScoreAssetManager.getImage("warning-icon.svg");

var final_threshold_icon = PartnerScoreAssetManager.getImage("final-threshold.svg");

var driver_thumb_icon = PartnerScoreAssetManager.getImage("driver-icon.svg");

var safe_milestone_icon = PartnerScoreAssetManager.getImage("safe-milestone-icon.svg");

var danger_milestone_icon = PartnerScoreAssetManager.getImage("danger-milestone-icon.svg");

var warning_milestone_icon = PartnerScoreAssetManager.getImage("warning-milestone-icon.svg");

var v1youtubeThumbnail = PartnerScoreAssetManager.getImage("v1-yt-thumbnail.webp");

var v2youtubeThumbnail = PartnerScoreAssetManager.getImage("v2-yt-thumbnail.jpg");

export {
  footer_icon ,
  lock_icon ,
  info_icon ,
  pin_icon ,
  video_icon ,
  close_icon ,
  error_img ,
  dropdown_icon ,
  warning_icon ,
  final_threshold_icon ,
  driver_thumb_icon ,
  safe_milestone_icon ,
  danger_milestone_icon ,
  warning_milestone_icon ,
  v1youtubeThumbnail ,
  v2youtubeThumbnail ,
  
}
/* footer_icon Not a pure module */
